module.exports = __webpack_public_path__ + "img/65400.80d60cb5.jpg";